angular.module("authoring/template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("authoring/template/tabs/tab.html",
    "<li role=\"presentation\" ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"authoring-tab nav-item\">\n" +
    "  <a role=\"tab\" id=\"link-{{index}}\" href ng-click=\"select($event)\" ng-keydown=\"keydown($event)\" class=\"nav-link\" tabindex=\"{{ active ? 0 : -1 }}\" authoring-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);



// WEBPACK FOOTER //
// ./app/common/tabs/template/tab.html.js